import { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Landmark, X } from "lucide-react";
import { toast } from "sonner";
import { Q, toB64, hoyGT } from "./util";

// Un depósito se registra una vez y puede agrupar varias operaciones.
export const DepositoDialog = ({ ops, onClose, onSaved }) => {
  const neto = Math.round(ops.reduce((s, o) => s + o.total, 0) * 100) / 100;
  const [bancos, setBancos] = useState([]);
  const [f, setF] = useState({ banco: "", num_transaccion: "", fecha: hoyGT(), monto: neto, foto_base64: "" });
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/bancos-activos").then(({ data }) => setBancos(data || [])).catch(() => {}); }, []);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const guardar = async () => {
    setBusy(true);
    try {
      await api.post("/mi-dinero/depositos", { ...f, monto: Number(f.monto), operaciones: ops.map((o) => ({ operacion: o.operacion, empresa: o.empresa })) });
      toast.success("Depósito registrado"); onSaved();
    } catch (e) { toast.error(formatApiError(e)); } finally { setBusy(false); }
  };
  return (
    <div className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center p-3" data-testid="deposito-dialog">
      <div className="bg-white rounded-2xl p-4 w-full max-w-md space-y-3">
        <div className="flex items-center gap-2 font-black"><Landmark className="w-5 h-5 text-violet-700" />Registrar depósito<button onClick={onClose} className="ml-auto" data-testid="deposito-cerrar"><X className="w-5 h-5" /></button></div>
        <div className="text-xs">Operaciones: <b>{ops.map((o) => o.operacion).join(", ")}</b> · Neto: <b><Q v={neto} /></b></div>
        <select value={f.banco} onChange={set("banco")} className="w-full border rounded px-2 py-2 text-sm" data-testid="deposito-banco">
          <option value="">Banco…</option>{bancos.map((b) => <option key={b.id}>{b.nombre}</option>)}
        </select>
        <input value={f.num_transaccion} onChange={set("num_transaccion")} placeholder="Número de transacción" className="w-full border rounded px-2 py-2 text-sm" data-testid="deposito-num" />
        <div className="flex gap-2">
          <input type="date" value={f.fecha} onChange={set("fecha")} className="flex-1 border rounded px-2 py-2 text-sm" data-testid="deposito-fecha" />
          <input type="number" step="0.01" value={f.monto} onChange={set("monto")} className="w-32 border rounded px-2 py-2 text-sm" data-testid="deposito-monto" />
        </div>
        <input type="file" accept="image/*" onChange={async (e) => { const x = e.target.files?.[0]; if (x) { const b64 = await toB64(x); setF((p) => ({ ...p, foto_base64: b64 })); } }} className="text-sm" data-testid="deposito-foto" />
        <Button disabled={busy} onClick={guardar} className="w-full bg-violet-700 hover:bg-violet-800" data-testid="deposito-guardar">Guardar depósito</Button>
      </div>
    </div>
  );
};
